import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @import '~antd/dist/antd.css';

    @font-face {
        font-family: "AlbertSans Light";
        src: url("/fonts/AlbertSans-Light.ttf") format("truetype");
        font-style: normal;
    }
    @font-face {
        font-family: "AlbertSans Medium";
        src: url("/fonts/AlbertSans-Medium.ttf") format("truetype");
        font-style: normal;
    }
    @font-face {
        font-family: "AlbertSans Regular";
        src: url("/fonts/AlbertSans-Regular.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "AlbertSans SemiBold";
        src: url("/fonts/AlbertSans-SemiBold.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "AlbertSans Bold";
        src: url("/fonts/AlbertSans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    html,
    a {
        font-family: 'AlbertSans Regular', sans-serif;
    }

    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        overflow-x: hidden;
        font-family: 'AlbertSans Regular', sans-serif;
    }

    h2 {
        line-height: 1.813rem;
        @media only screen and (min-width: 768px) {
            line-height: 2.375rem;
        }
    }

    h6 {
        line-height: 1.25rem;
        @media only screen and (min-width: 768px) {
            line-height: 1.375rem;
        }
    }

    a:hover {
        color: #18216d;
    }

    input {
        height: 45px !important;
        max-height: 45px;
        width: 100%;
    }
   

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding: 14px 12px;

    }

    .ant-drawer-content-wrapper {
        width: 220px !important;
    }

    iframe {
        border: 0;
        height: 85vh;
    }

    .modal-consulta-imobiliarias {
        top: 5px;
        .ant-modal-body {
            max-height: 80vh;
            min-height: 80vh;

        }

        .ant-radio-group {
            padding: 1rem 0;
            max-height: 70vh;
            overflow-y: auto;
            width: 100%;
        }
    }

    .ant-drawer-content {
        background-color: #202C27;
    }

    .ant-space-vertical{
        width: 100%;
    }

    .ant-input-affix-wrapper {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .ant-collapse {
        background: transparent;
    }

    .ant-message {
        
        .ant-message-notice-content {
            background-color: #202C27;
            color: #fff;
        }

        .ant-message-notice-close-x {
            color: #fff;
        }
    }

    .wpp-btn-icon {
        height: 1px;

        svg {
            height: 22px;
        }
    }

    .tabela-cinza {
        background-color: #f5f7f5;
        border-radius: 12px;
        border: 2em solid #f5f7f5;
        overflow: hidden;
        font-family: "Segoe UI", sans-serif;
    }

    .ant-tabs-tab:hover {
        color: #52c41a !important;
    }

    .tabela-cinza .ant-table-container {
        border: none;
    }

    .tabela-cinza .ant-table-content {
        background-color: #f5f7f5;
    }

    .tabela-cinza .ant-table-thead > tr > th {
        background-color: #f0f6f2;
        color: #333;
        font-weight: 500;
        border-bottom: 1px solid #dcdcdc;
    }

    .tabela-cinza .ant-btn {
        color: #333;
    }

    .tabela-cinza .ant-table-tbody > tr > td {
        background-color: #f5f7f5;
        border-bottom: 1px solid #dcdcdc;
        color: #333;
    }

    .tabela-cinza .ant-table-tbody > tr:hover > td {
        background-color: #eaf1ea;
    }

    .tabela-cinza .ant-table-pagination {
        background-color: transparent;
        padding: 16px;
        font-family: "Segoe UI", sans-serif;
    }

    .tabela-cinza .ant-pagination-item {
        border: none;
        background: transparent;
        color: #333;
    }

    .tabela-cinza .ant-pagination-item-active {
        border: none;
        background-color: transparent;
        color: #40916c !important;
        font-weight: 500;
    }

    .tabela-cinza .ant-pagination-item-active a {
        color: #40916c !important;
    }

    .tabela-cinza .ant-pagination-prev,
    .tabela-cinza .ant-pagination-next {
        color: #333;
    }

    .tabela-cinza .ant-pagination-item:hover {
        color: #40916c;
    }

    .tabela-cinza .ant-select-selector {
        background-color: #ECF0EF !important;
    }


    .tabela-cinza .ant-pagination-item-link {
        background: transparent;
        border: none;
    }

`;
